<div class="inner-content">
    <app-old-system-iframe
        [hidden]="!headlineService.moduleStates['inspector']"
        (show)="headlineService.moduleStates['inspector'] = $event"
        src="administration/Inspector"
        key="check_hippo"></app-old-system-iframe>

    @if (!hasPageAccess) {
        <div
            *ngIf="!headlineService.moduleStates['inspector']"
            class="h-full">
            <app-no-page-access></app-no-page-access>
        </div>
    } @else {
        <div
            *ngIf="!headlineService.moduleStates['inspector'] && data"
            class="p-4">
            <mat-card class="w-full border border-[#8CAACD] bg-[#E6F0FF]">
                <mat-card-content>
                    <div class="flex gap-2 justify-center items-center">
                        <div>Last check:</div>
                        <div
                            class="cursor-pointer font-semibold text-lg"
                            (click)="setLastDayTimestamp()">
                            {{
                                date === null
                                    ? data.date
                                    : data.date.slice(0, -9)
                            }}
                        </div>
                        <button
                            mat-raised-button
                            *ngIf="date"
                            (click)="resetTimestamp()">
                            Reset
                        </button>
                    </div></mat-card-content
                ></mat-card
            >
            <mat-card class="w-full border mt-4 border-[#8CAACD] bg-[#E6F0FF]">
                <mat-card-content>
                    <div class="w-fit">
                        <table>
                            <tr>
                                <td
                                    class="!pt-4 font-bold"
                                    colspan="2">
                                    Log files
                                </td>
                            </tr>
                            <tr>
                                <td
                                    class="!p-0"
                                    colspan="2">
                                    <hr class="m-0 p-0 border-[#8CAACD]" />
                                </td>
                            </tr>

                            <tr>
                                <td>common log:</td>
                                <td>
                                    <lucide-icon
                                        [img]="CircleIcon"
                                        [size]="16"
                                        [ngClass]="getLogsIconColor(data.logs.common.file_status)"
                                        class="cursor-pointer filled-bullet"
                                        (click)="openLogFileWindow('common')"></lucide-icon>
                                </td>
                            </tr>
                            <tr>
                                <td>hippodata log:</td>
                                <td>
                                    <lucide-icon
                                        [img]="CircleIcon"
                                        [size]="16"
                                        [ngClass]="getLogsIconColor(data.logs.database.hd.file_status)"
                                        class="cursor-pointer filled-bullet"
                                        (click)="openLogFileWindow('hd')"></lucide-icon>
                                </td>
                            </tr>
                            <tr>
                                <td>hippodata central log:</td>
                                <td>
                                    <lucide-icon
                                        [img]="CircleIcon"
                                        [size]="16"
                                        [ngClass]="getLogsIconColor(data.logs.database.hd_central.file_status)"
                                        class="cursor-pointer filled-bullet"
                                        (click)="openLogFileWindow('hdc')"></lucide-icon>
                                </td>
                            </tr>
                            <tr>
                                <td>hippodata store log:</td>
                                <td>
                                    <lucide-icon
                                        [img]="CircleIcon"
                                        [size]="16"
                                        [ngClass]="getLogsIconColor(data.logs.database.hd_store.file_status)"
                                        class="cursor-pointer filled-bullet"
                                        (click)="openLogFileWindow('hds')"></lucide-icon>
                                </td>
                            </tr>
                            <tr>
                                <td
                                    class="pt-4 font-bold"
                                    colspan="2">
                                    Databases
                                </td>
                            </tr>
                            <tr>
                                <td
                                    class="!p-0"
                                    colspan="2">
                                    <hr class="m-0 p-0 border-[#8CAACD]" />
                                </td>
                            </tr>
                            <tr>
                                <td>hippodata central:</td>
                                <td>
                                    <lucide-icon
                                        [img]="CircleIcon"
                                        [size]="16"
                                        class="filled-bullet"
                                        [ngClass]="getLogsIconColor(data.database.hd_central.status)"></lucide-icon>
                                </td>
                            </tr>
                            <tr>
                                <td>hippodata:</td>
                                <td>
                                    <lucide-icon
                                        [img]="CircleIcon"
                                        [size]="16"
                                        class="filled-bullet"
                                        [ngClass]="getLogsIconColor(data.database.hd.status)"></lucide-icon>
                                </td>
                            </tr>
                            <tr>
                                <td>hippodata logistics:</td>
                                <td>
                                    <lucide-icon
                                        [img]="CircleIcon"
                                        [size]="16"
                                        class="filled-bullet"
                                        [ngClass]="getLogsIconColor(data.database.hd_store.status)"></lucide-icon>
                                </td>
                            </tr>
                            <tr>
                                <td>hippo Administration:</td>
                                <td>
                                    <lucide-icon
                                        [img]="CircleIcon"
                                        [size]="16"
                                        class="filled-bullet"
                                        [ngClass]="getLogsIconColor(data.database.hd_base.status)"></lucide-icon>
                                </td>
                            </tr>
                            <tr>
                                <td
                                    class="pt-4 font-bold"
                                    colspan="2">
                                    Jobs
                                </td>
                            </tr>
                            <tr>
                                <td
                                    class="!p-0"
                                    colspan="2">
                                    <hr class="m-0 p-0 border-[#8CAACD]" />
                                </td>
                            </tr>
                            <tr>
                                <td>invoice check:</td>
                                <td>
                                    <lucide-icon
                                        [img]="CircleIcon"
                                        [size]="16"
                                        [ngClass]="getInvoiceCheckIconColor(data.jobs.invoice_check.file_status)"
                                        class="cursor-pointer filled-bullet"
                                        (click)="requestInvoiceInformation()"></lucide-icon>
                                </td>
                            </tr>
                        </table>
                    </div> </mat-card-content
            ></mat-card>
        </div>
    }
</div>
